<div class="component-container">
  @let image = config().image;
  @if (image) {
    <img alt="" class="image" [src]="image" />
  }
  <div
    class="label"
    [style]="{
      color: config().label.color,
      fontFamily: config().label.fontFamily,
    }"
  >
    {{ config().label.text }}
  </div>
  <a
    class="link"
    target="_blank"
    [href]="config().link.href"
    [style]="{
      color: config().link.color,
      fontFamily: config().link.fontFamily,
      backgroundColor: config().link.backgroundColor,
    }"
    >{{ config().link.text }}</a
  >
</div>
